// import React, { useState, useEffect } from 'react';
// import Navbar from './componants/Navbar';
// import Hero from './pages/Hero';
// import RegisterModal from './componants/RegisterModal';
// import ScrollRevealImage from './pages/RevealImage';
// import PastGlimpses from './pages/PastGlimpses';
// import WebinarSection from './pages/WebinarSection';


// const App: React.FC = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const hasSeenPopup = sessionStorage.getItem('pwnsat_v1_shown');
    
//     if (!hasSeenPopup) {
//       const timer = setTimeout(() => {
//         setIsModalOpen(true);
//         sessionStorage.setItem('pwnsat_v1_shown', 'true');
//       }, 5000);

//       return () => clearTimeout(timer);
//     }
//   }, []);

//   return (
//     <div className="min-h-screen w-full bg-[#9e1c22]">
//       <Navbar onRegisterClick={() => setIsModalOpen(true)} />
//       <Hero />
//       <ScrollRevealImage />
//       <PastGlimpses />
//       <WebinarSection />
//       <RegisterModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
//     </div>
//   );
// };

// export default App;


import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Ye naya add kiya
import Navbar from './componants/Navbar';
import Hero from './pages/Hero';
import RegisterModal from './componants/RegisterModal';
import ScrollRevealImage from './pages/RevealImage';
import PastGlimpses from './pages/PastGlimpses';
import WebinarSection from './pages/WebinarSection';
import LeadsDashboard from './pages/LeadsDashboard'; // Naya Page Import kiya

const App: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem('pwnsat_v1_shown');
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setIsModalOpen(true);
        sessionStorage.setItem('pwnsat_v1_shown', 'true');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* TUMHARI MAIN WEBSITE */}
        <Route path="/" element={
          <div className="min-h-screen w-full bg-[#9e1c22]">
            <Navbar onRegisterClick={() => setIsModalOpen(true)} />
            <Hero />
            <ScrollRevealImage />
            <PastGlimpses />
            <WebinarSection />
            <RegisterModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
          </div>
        } />
        
        {/* TUMHARA NAYA LEADS ROUTE */}
        <Route path="/nv-pw-leads2026" element={<LeadsDashboard />} />
      </Routes>
    </Router>
  );
};

export default App;